module.exports = __webpack_public_path__ + "static/media/overpass-mono-regular.052fe015.woff2";